import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';

@Component({
    selector: 'lex-file-size-warning',
    templateUrl: './file-size-warning.component.html',
    styleUrls: ['./file-size-warning.component.scss'],
    standalone: false
})
export class FileSizeWarningComponent implements OnInit {
	@Input() fileSize: number;
	@Output() pageView = new EventEmitter();

	public t3Time: string;
	public turboCableTime: string;
	public cableDslTime: string;
	public t1Time: string;

	constructor(private docViewerStore: DocViewerStore) {
	}

	public viewAsNative() : void {
		this.docViewerStore.updateState((current) => {
			current.showOriginalSizeWarning = false;
			current.showPdfSizeWarning = false;
			return current;
		})
	}

	public ngOnInit() {
		this.t3Time = this.getFormattedDownloadTime(this.fileSize, 44.736);
		this.turboCableTime = this.getFormattedDownloadTime(this.fileSize, 15);
		this.cableDslTime = this.getFormattedDownloadTime(this.fileSize, 3);
		this.t1Time = this.getFormattedDownloadTime(this.fileSize, 1.544);
	}

	private getFormattedDownloadTime(inDownloadSizeMB: number, inDownloadRateMBPS: number): string {
		let downloadTime = '';

		if (inDownloadRateMBPS > 0) {
			const downloadTimeSecs = inDownloadSizeMB * 8 / inDownloadRateMBPS;
			downloadTime = Math.ceil(downloadTimeSecs / 60.0).toString();
		}

		return downloadTime;
	}
}
